import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/apple-pay.svg")